export enum InputFields {
  airFlow = 'air_flow',
  ambientTemperature = 'ambient_temperature',
  dewPoint = 'dew_point',
  inletTemperature = 'inlet_temperature',
  pressure = 'pressure',
  waterTemperature = 'water_inlet_temperature',
  phase = 'phase',
  frequency = 'frequency',
  unit = 'unit',
  options = 'options',
  voltage = 'voltage',
  model = 'model',
  desiccantDewPoint = 'desiccant_dew_point',
  highInletTemperature = 'high_inlet_temperature',
  maxInletTemperature = 'max_inlet_temperature',
  minInletTemperature = 'min_inlet_temperature',
}
